/* WeekendBoost — animated banner shown on Sat/Sun to highlight 2x karma multiplier.
 * Pulses, sparkles, gradient sweep. Hidden weekday.
 */
import React from "react";
import { motion } from "framer-motion";
import { Zap, Sparkles } from "lucide-react";

export default function WeekendBoost({ active }) {
  if (!active) return null;
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.94, y: 6 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      data-testid="weekend-boost"
      className="relative mt-5 rounded-2xl p-3.5 sm:p-4 overflow-hidden border"
      style={{
        background: "linear-gradient(120deg, #FF7A1A 0%, #F4B83C 55%, #FF7A1A 100%)",
        backgroundSize: "200% 100%",
        borderColor: "#F4B83C",
        boxShadow: "0 14px 36px -10px rgba(255,122,26,0.55), 0 2px 8px -2px rgba(0,0,0,0.06)",
      }}
    >
      {/* Animated shimmer sweep across the gradient */}
      <motion.div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        animate={{ backgroundPositionX: ["0%", "200%"] }}
        transition={{ duration: 3.6, repeat: Infinity, ease: "linear" }}
        style={{
          background: "linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.25) 50%, transparent 100%)",
          backgroundSize: "200% 100%",
          mixBlendMode: "overlay",
        }}
      />
      {/* Floating sparkles */}
      {[0, 1, 2, 3, 4].map((i) => (
        <motion.div
          key={i}
          aria-hidden
          className="absolute pointer-events-none"
          initial={{ y: 0, opacity: 0 }}
          animate={{ y: -32, opacity: [0, 1, 0] }}
          transition={{ duration: 2.4, delay: i * 0.45, repeat: Infinity, ease: "easeOut" }}
          style={{
            left: `${12 + i * 18}%`,
            bottom: 8,
            width: 4 + (i % 2) * 2,
            height: 4 + (i % 2) * 2,
            background: "#FFFFFF",
            borderRadius: "50%",
            boxShadow: "0 0 8px rgba(255,255,255,0.85)",
          }}
        />
      ))}

      <div className="relative z-10 flex items-center gap-3">
        <motion.div
          className="h-10 w-10 rounded-xl bg-white/95 flex items-center justify-center shrink-0"
          animate={{ rotate: [0, -8, 8, -8, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, repeatDelay: 1.4 }}
          style={{ boxShadow: "0 4px 12px -2px rgba(0,0,0,0.18)" }}
        >
          <Zap className="h-5 w-5 text-[#FF7A1A]" strokeWidth={2.6} />
        </motion.div>
        <div className="flex-1 min-w-0 text-white">
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-bold opacity-90">
            <Sparkles className="h-2.5 w-2.5" /> Bonus weekend
          </div>
          <div className="font-display text-[18px] sm:text-[20px] leading-tight mt-0.5">
            Karma raddoppiato oggi
          </div>
          <div className="text-[11px] opacity-90 mt-0.5 truncate">
            Ogni segnalazione, conferma o missione conta x2
          </div>
        </div>
        <motion.div
          className="shrink-0 px-2.5 py-1.5 rounded-full bg-white text-[#FF7A1A] font-display text-[15px] font-bold leading-none"
          animate={{ scale: [1, 1.08, 1] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          style={{ boxShadow: "0 4px 12px -3px rgba(0,0,0,0.22)" }}
        >
          x2
        </motion.div>
      </div>
    </motion.div>
  );
}
